export const API_COLLECTION_ROUTES = {
  COLLECTIONS: '/collection',
  COLLECTION: '/collection/:collectionId',
  COLLECTION_CREATORS: '/collection/:collectionId/creators',
};
